<template>
  <v-dialog v-model="open" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ $T('page.member.invite.method.mail.title') }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <select-community v-model="communityId" ref="selectCommunity" />
          </v-flex>
          <v-flex>
            <div class="c-flex-container">
              <div class="l">
                <v-select
                  data-vv-name="expire"
                  :items="expireItems()"
                  ref="'input_expire'"
                  :label="$T('attributes.expire')"
                  v-model="expire"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('expire')"
                  required
                  :disabled="loading"
                ></v-select>
              </div>
              <div class="r">
                <v-select
                  data-vv-name="expireUnit"
                  :items="expireUnits()"
                  item-text="t"
                  item-value="v"
                  ref="'input_expire_unit'"
                  v-model="expireUnit"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('expireUnit')"
                  required
                  :disabled="loading"
                ></v-select>
              </div>
            </div>
          </v-flex>
          <v-flex>
            <v-text-field
              data-vv-name="invite_name"
              data-vv-validate-on="blur"
              ref="input_invite_name"
              :label="$T('attributes.invite_name')"
              v-model="invite_name"
              color="clr-primary"
              v-validate="'required|max:50'"
              :error-messages="getMessage('invite_name')"
              required
              :disabled="loading"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-textarea
              auto-grow
              data-vv-name="invite_mails"
              data-vv-validate-on="blur"
              ref="input_invite_mails"
              :label="$T('attributes.invite_mails')"
              :hint="$T('page.member.invite.mail.input.hint', { max: 50 })"
              v-model="invite_mails"
              color="clr-primary"
              v-validate="'required|emails:50'"
              :error-messages="getMessage('invite_mails')"
              required
              :disabled="loading"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="closeDialog" :disabled="loading">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="createNew" :disabled="!isSavable" :loading="loading">{{
          $T('page.member.invite.create.button')
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { invitable, createInviteEmailLinks, getProfileName } from '../../api/communityMember';
import { emailsValidator } from '../../utils/customValidators';

export default {
  created() {
    this.$validator.extend('emails', emailsValidator);
  },
  data() {
    return {
      communityId: null,
      expire: null,
      expireUnit: null,
      invite_name: null,
      invite_mails: null,
      creatable: false,
      open: false,
      loading: false,
      apiErrors: {},
    };
  },
  watch: {
    communityId(newValue, oldValue) {
      if (newValue <= 0) {
        this.creatable = false;
        if (newValue == 0) {
          this.changeSenderName();
        }
        return;
      }
      this.loading = true;
      this.creatable = false;
      var _this = this;
      invitable(newValue)
        .then(function(response) {
          _this.creatable = response == 1 || response == 2;
          if (!_this.creatable) {
            _this.$refs.selectCommunity.addError(newValue, $T('page.member.invite.noauth'));
          } else {
            _this.changeSenderName();
          }
          _this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.loading = false;
        });
    },
  },
  computed: {
    isSavable() {
      return !this.isFormInValid && !this.loading && this.creatable;
    },
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
  },
  methods: {
    createNew() {
      var cid = this.communityId;
      var data = new FormData();
      data.append('cid', cid);
      data.append('expire', this.expire);
      data.append('expireUnit', this.expireUnit);
      data.append('invite_name', this.invite_name);
      data.append('invite_mails', this.invite_mails);

      this.loading = true;
      var _this = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          createInviteEmailLinks(data)
            .then(function(response) {
              _this.$emit('invited', 'mail', cid, data);
              _this.loading = false;
              _this.shortMsg($T('page.member.invite.mail.sent'));
              _this.closeDialog();
            })
            .catch(function(error) {
              console.log(error);
              _this.$refs.selectCommunity.addError(cid, $T('common.failed.register'));
              _this.loading = false;
            });
        } else {
          _this.loading = false;
          console.warn('there is invalid values.');
        }
      });
    },
    changeSenderName() {
      var cid = this.communityId;
      if ((this.invite_name && this.fields.invite_name.dirty) || cid < 0) {
        return;
      }

      var _this = this;
      getProfileName(cid)
        .then(function(response) {
          if (_this.invite_name && _this.fields.invite_name.dirty) {
            return;
          }
          _this.invite_name = response.name;
          _this.fields.invite_name.dirty = false;
          _this.fields.invite_name.invalid = false;
          _this.fields.invite_name.valid = true;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    openDialog(defaultName, expire, expireUnit, communityId) {
      this.invite_name = defaultName;
      this.fields.invite_name.dirty = false;
      this.fields.invite_name.invalid = !defaultName || defaultName == '';
      this.invite_mails = null;
      this.fields.invite_mails.invalid = true;
      this.expire = expire;
      this.fields.expire.invalid = false;
      this.expireUnit = expireUnit;
      this.fields.expireUnit.invalid = false;
      this.communityId = communityId;
      this.open = true;
      setTimeout(this.initFocus, 500);
    },
    initFocus() {
      if (!this.communityId) {
        this.$refs.selectCommunity.focus();
        return;
      }
      if (!this.invite_name) {
        this.$refs.input_invite_name.focus();
        return;
      }
      if (!this.invite_mails) {
        this.$refs.input_invite_mails.focus();
        return;
      }
    },
    closeDialog() {
      this.open = false;
    },
    expireItems() {
      var vs = [];
      for (var i = 1; i <= 100; i++) {
        vs.push(i);
      }
      return vs;
    },
    expireUnits() {
      return [
        { v: 'm', t: $T('common.unit.min') },
        { v: 'h', t: $T('common.unit.hour') },
        { v: 'd', t: $T('common.unit.day') },
        { v: 'M', t: $T('common.unit.month') },
        { v: 'y', t: $T('common.unit.year') },
      ];
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-flex-container {
  display: flex;
  width: 250px;
}
.c-flex-container .l {
  width: 150px;
}
.c-flex-container .r {
  width: 90px;
  padding-left: 10px;
}
</style>
